import * as firebase from 'firebase'

const config = {
  apiKey: 'AIzaSyDG5HVe4RsXwHcBnSsRuREaD3I8jh7UH6U',
  authDomain: 'smart-cart-aea3d.firebaseapp.com',
  databaseURL: 'https://smart-cart-aea3d.firebaseio.com',
  projectId: 'smart-cart-aea3d',
  storageBucket: 'smart-cart-aea3d.appspot.com',
  messagingSenderId: '700025491509'
}

if (!firebase.apps.length) {
  firebase.initializeApp(config)
}

const auth = firebase.auth()
const db = firebase.database()

export { auth, db }



// WEBPACK FOOTER //
// ./src/firebase/firebase.js